function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 0.375C3.7878 0.375 0.375 3.7878 0.375 8C0.375 12.2122 3.7878 15.625 8 15.625C12.2122 15.625 15.625 12.2122 15.625 8C15.625 3.7878 12.2122 0.375 8 0.375ZM8 14.1492C4.60257 14.1492 1.85081 11.3974 1.85081 8C1.85081 4.60257 4.60257 1.85081 8 1.85081C11.3974 1.85081 14.1492 4.60257 14.1492 8C14.1492 11.3974 11.3974 14.1492 8 14.1492ZM9.9001 10.9393L7.28977 9.04229C7.19446 8.97157 7.13911 8.86089 7.13911 8.74405V3.69556C7.13911 3.49264 7.30514 3.32661 7.50806 3.32661H8.49194C8.69486 3.32661 8.86089 3.49264 8.86089 3.69556V8.05227L10.9147 9.54652C11.0807 9.66643 11.1146 9.89703 10.9947 10.0631L10.4166 10.8594C10.2967 11.0223 10.0661 11.0592 9.9001 10.9393Z",
  fill: "#6B7785"
});
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.ec8af3fc.svg";
export { ForwardRef as ReactComponent };